import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext";
import DeleteDialogIcon from "@entrilia/shared/icons/DeleteDialogIcon";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../../api/adminApi";

const deleteFundraising = withErrorHandling(adminApi.deleteFundraising);

interface Props {
  fundraisingId: string;
  fundraisingName: string;
  onClose: () => void;
  onDeleted: () => void;
}

const DeleteFundraisingDialog = ({ fundraisingId, fundraisingName, onClose, onDeleted }: Props) => {
  const { sendNotification, sendNotificationError } = useNotificationContext();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    setSaving(true);
    const [, error] = await deleteFundraising(fundraisingId);
    setSaving(false);

    if (error) {
      logError(error, "[DeleteFundraisingDialog]");
      sendNotificationError(error.message);
      return;
    }

    sendNotification("Fundraising deleted successfully");
    onDeleted();
  };

  return (
    <SmallDialog open onClose={onClose}>
      <DialogTitle>Delete Fundraising</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <DeleteDialogIcon sx={{ width: 80, height: 80 }} />
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Typography noWrap variant="h6">
              Delete fundraising?
            </Typography>
            <Typography color="textSecondary" sx={{ textAlign: "center" }}>
              You&apos;re about to delete fundraising <strong>{fundraisingName}</strong>.<br /> This action is permanent
              and can&apos;t be undone.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="outlined" color="error" loading={saving} onClick={handleSubmit}>
          Delete
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default DeleteFundraisingDialog;
